/* Keepsake Lines fixes 20-oct: confirmation text for every portrait + clearer Preview button. */
(function () {
  'use strict';
  var p = location.pathname;
  if (p.indexOf('/products/') === -1) return;
  if (p.indexOf('/products/watercolor-golf-course-map') > -1 || p.indexOf('/products/signature-hole-print') > -1) return;
  var CONFIRM = "I've checked my preview and I'm happy with it (photo, spelling and details).";
  var CSS = '.kl-prev-btn{display:flex!important;align-items:center;justify-content:center;width:100%;min-height:52px;border:1.5px solid #2F4A3A!important;border-radius:999px!important;background:#fff!important;color:#2F4A3A!important;font-weight:600!important;letter-spacing:.06em;cursor:pointer;box-shadow:none!important}.kl-prev-btn:hover{background:#F2EDE4!important}';
  if (!document.getElementById('kl-prev-css')) { var st = document.createElement('style'); st.id = 'kl-prev-css'; st.textContent = CSS; document.head.appendChild(st); }
  function run() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue || '';
      if (v.indexOf('checked my preview') > -1 && v !== CONFIRM) n.nodeValue = CONFIRM;
    }
    var list = document.querySelectorAll('button');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if ((b.textContent || '').trim().toLowerCase() === 'preview' && !b.classList.contains('kl-prev-btn') && !b.closest('.kl-zm, dialog')) b.classList.add('kl-prev-btn');
    }
  }
  var t = null;
  function scan() { clearTimeout(t); t = setTimeout(run, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  try { new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {}
})();
